(() => {
  const nav = document.querySelector(".primary-nav");
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll(".nav-item"));

  const closeAll = (except = null) => {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove("is-open");
      const btn = item.querySelector(":scope > .nav-button");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
  };

  // Toggle dropdown on click
  items.forEach((item) => {
    const btn = item.querySelector(":scope > .nav-button");
    const dd = item.querySelector(":scope > .nav-dropdown");
    if (!btn || !dd) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const willOpen = !item.classList.contains("is-open");
      closeAll(item);
      item.classList.toggle("is-open", willOpen);
      btn.setAttribute("aria-expanded", String(willOpen));
    });
  });

  // Close on outside click + Escape
  document.addEventListener("click", (e) => {
    if (!nav.contains(e.target)) closeAll();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // --- 2-level switching + keyboard access ---
  const wideItem = nav.querySelector(".nav-item--wide");
  if (!wideItem) return;

  const level1 = wideItem.querySelector("[data-level1]");
  const level2 = wideItem.querySelector("[data-level2]");
  const divider = wideItem.querySelector(".nav-dropdown-divider");
  if (!level1 || !level2 || !divider) return;

  const links = Array.from(level1.querySelectorAll("a[data-submenu]"));
  const panels = Array.from(level2.querySelectorAll(".nav-dropdown-panel[data-panel]"));

  const getActivePanel = () =>
    level2.querySelector(".nav-dropdown-panel.is-active");

  const getFirstLinkInActivePanel = () =>
    getActivePanel()?.querySelector("a, button, [tabindex]:not([tabindex='-1'])");

  const moveNotchToLink = (linkEl) => {
    const linkRect = linkEl.getBoundingClientRect();
    const menuRect = level1.getBoundingClientRect();
    const y = (linkRect.top + linkRect.height / 2) - menuRect.top;
    divider.style.setProperty("--notch-y", `${Math.round(y)}px`);
  };

  const setActive = (key, linkEl) => {
    links.forEach((a) => a.classList.toggle("is-active", a.dataset.submenu === key));

    panels.forEach((p) => {
      const isActive = p.dataset.panel === key;
      p.classList.toggle("is-active", isActive);

      // Make only active panel focusable
      if (isActive) {
        p.removeAttribute("hidden");
        p.inert = false;
      } else {
        p.setAttribute("hidden", "");
        p.inert = true;
      }
    });

    if (linkEl) moveNotchToLink(linkEl);
  };

  // Default active
  if (links[0]) setActive(links[0].dataset.submenu, links[0]);

  // Switch panel on hover/focus; and enable keyboard “enter right panel”
  links.forEach((a) => {
    const key = a.dataset.submenu;

    a.addEventListener("mouseenter", () => setActive(key, a));
    a.addEventListener("focus", () => setActive(key, a));

    // Keep click behavior: switch panel (remove preventDefault if you want navigation)
    a.addEventListener("click", (e) => {
      e.preventDefault();
      setActive(key, a);
    });

    // Keyboard bridge: ArrowRight / Enter / Space goes into level 2
    a.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight" || e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setActive(key, a);
        getFirstLinkInActivePanel()?.focus();
      }
    });
  });

  // From within level-2, ArrowLeft returns to active level-1
  level2.addEventListener("keydown", (e) => {
    if (e.key !== "ArrowLeft") return;
    const activeLeft = level1.querySelector("a.is-active[data-submenu]") || links[0];
    if (activeLeft) {
      e.preventDefault();
      activeLeft.focus();
    }
  });

  // Reposition notch on resize
  window.addEventListener("resize", () => {
    const activeLeft = level1.querySelector("a.is-active[data-submenu]") || links[0];
    if (activeLeft) moveNotchToLink(activeLeft);
  });
})();
